<main>
  <p-toast></p-toast>
  <router-outlet />
</main>

<p-confirmDialog [closable]="false" [draggable]="false" />
